import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PurchasesAssociationService {

  private url = environment.api + "api/erp/purchase/orders/association";
    constructor(
        private http: HttpClient
  ) { }

  getRelatedPurchasesByOrder(orderId: number) {
      return this.http.get(this.url+`/${orderId}/providers`);
  }

  getRelatedOrdersByPurchase(purchaseId: number) {
      return this.http.get(this.url+`/${purchaseId}/orders`);
  }

  getRelatedOrdersByType(type: string) { // El type se coloca acorde al enum del back AssociationOrderPurchaseEnum
      return this.http.get(this.url+`/related-orders`, {
        params: { type }
      });
  }

  getRelatedOrdersByNoRelated(type: string) { // El type se coloca acorde al enum del back AssociationOrderPurchaseEnum
      return this.http.get(this.url+`/not-related-orders`, {
        params: { type }
      });
  }

  createRelationPurchaseOrder(purchaseOrderId: number, providerInvoiceId: number) {
    const body = {
      purchaseOrderId, 
      providerInvoiceId,
      type: "TRANSIT"
    }
    
    return this.http.post(this.url+`/create`, body);
  }

  createRelationPurchaseOrderByInvoice(purchaseOrderId: number, providerInvoiceId: number, transformation:boolean) {
    const body = {
      purchaseOrderId, 
      providerInvoiceId,
      type: "TRANSIT",
      transformation: transformation
    }
    
    return this.http.post(this.url+`/create/invoices`, body);
  }

  createRelationPurchaseOrderIngress(purchaseOrderId: number, providerInvoiceId: number) {
    const body = {
      purchaseOrderId, 
      providerInvoiceId,
      type: "INGRESS"
    }
    
    return this.http.post(this.url+`/create`, body);
  }

  deleteRelationPurchaseOrder(orderId: number, purchaseId: number) {
    return this.http.delete(this.url+`/remove/${orderId}/${purchaseId}`);
  }

  putInventoriesForOrder(orderId: number, data: any) {    
    return this.http.put(this.url+`/inventories-order/${orderId}`, data);
  }

  putInventoriesForOrderByInvoice(invoiceId: number, data: any) {
    return this.http.put(this.url+`/inventories-order/invoices/${invoiceId}`, data);
  }
}
